import { useMutation, useQueryClient } from "react-query";
import immer from "immer";
import { useContext } from "react";
import { toast } from "react-toastify";
import { FetchContext } from "../context/FetchContext";

export const useSyncOnesky = (projectId, version) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();
  const queryKey = [
    "project",
    projectId.toString(),
    "version",
    version?.toString(),
    "keys",
  ];

  return useMutation(
    async () => {
      const { data } = await fetchContext.authAxios.post(
        `/projects/${projectId}/versions/${version}/sync_onesky`
      );
      return data;
    },
    {
      onSettled: (data, error, keyId) => {
        queryClient
          .getQueryCache()
          .findAll(queryKey)
          .forEach(({ queryKey }) => {
            const previousKeys = queryClient.getQueryData(queryKey);
            const newKeys = immer(previousKeys, (draft) => {
              // eslint-disable-next-line no-restricted-syntax
              for (const stringKey of data) {
                const index = draft.findIndex((key) => key.id === stringKey.id);
                if (index !== -1) {
                  draft[index] = stringKey;
                }
              }
            });
            queryClient.setQueryData(queryKey, newKeys);
          });
        toast.success("Sync Completed");
      },
    }
  );
};
